(function () {
  if (customElements.get('copy-button')) return;
  customElements.define(
    'copy-button',
    class CopyButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-copy-label]');
        this.originalText = this.label ? this.label.textContent : '';
        this.value = this.dataset.copyValue || '';

        if (this.button) {
          this.button.addEventListener('click', () => this.copy());
        }
      }

      copy() {
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(this.value).then(() => {
          if (!this.label) return;
          this.label.textContent = 'Copied!';
          clearTimeout(this._resetTimer);
          this._resetTimer = setTimeout(() => {
            this.label.textContent = this.originalText;
          }, 1500);
        });
      }
    }
  );
})();
